import Tracking from '@/services/browser/Tracking'
const addClass = (element, className) => {
  if(element.className.indexOf(className) != -1 ) return;
  element.classList.add(className);
  //if(element.className != '' ) className = ' '+className;
  //element.className+= className;
}
const removeClass = (element, className) => {
  element.classList.remove(className);
  //element.className = element.className.replace(new RegExp('(?:^|s)' + className + '(?!S)'), '');
}
const isTouchDevice = () => {
  try {
    document.createEvent("TouchEvent");
    return true;
  } catch(e) {
    return false;
  }
}
const playFree = () => {
  if(window.nexon){
    var game = "SVG011";
    window.nexon.play(game);
    // const redirectUrl = location.origin + location.pathname;
    // window.nexon.gnt.signupGlobal(redirectUrl, 10100);
  }
}
const isScrolledIntoView = (el) => {        
  const elemTop = parseInt(el.getBoundingClientRect().top + window.scrollY,10);
  const elemBottom = parseInt(elemTop + el.offsetHeight,10);
  const pageY = window.pageYOffset;
  //console.log(el, pageY, elemTop, elemBottom)
  return (pageY >= (elemTop-500)) && (pageY <= elemBottom);
}
const sendTrackingEvent = ( trackingEventTitle, trackingEventItem, trackingType ) => {
  let gtmData;
  if( trackingType && trackingType == "view"){
    gtmData = {
      event: 'Element View',
      ec: trackingEventTitle,
      ea: 'view',
      el: trackingEventItem,
      noninteraction: true
    }
  } else {
    gtmData = {
      event: 'Transition Event',
      ec: trackingEventTitle,
      ea: 'click',
      el: trackingEventItem
    }
  }
  Tracking.sendEvent(gtmData);
}
export default { 
  playFree,
  addClass,
  removeClass,
  isTouchDevice,
  isScrolledIntoView,
  sendTrackingEvent
}